/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Cities from '../model/Cities';
import ProvinceItem from '../model/ProvinceItem';

/**
* Adress service.
* @module api/AdressApi
* @version 1.0.0
*/
export default class AdressApi {

    /**
    * Constructs a new AdressApi. 
    * @alias module:api/AdressApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Obtener ciudades por ID de provincia
     * Devuelve una lista de ciudades filtradas por el ID de la provincia.
     * @param {Number} provinceId ID de la provincia
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Cities>} and HTTP response
     */
    apiV1MyaccountCitiesProvinceIdGetWithHttpInfo(provinceId) {
      let postBody = null;
      // verify the required parameter 'provinceId' is set
      if (provinceId === undefined || provinceId === null) {
        throw new Error("Missing the required parameter 'provinceId' when calling apiV1MyaccountCitiesProvinceIdGet");
      }

      let pathParams = {
        'provinceId': provinceId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Cities];
      return this.apiClient.callApi(
        '/api/v1/myaccount/cities/{provinceId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Obtener ciudades por ID de provincia
     * Devuelve una lista de ciudades filtradas por el ID de la provincia.
     * @param {Number} provinceId ID de la provincia
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Cities>}
     */
    apiV1MyaccountCitiesProvinceIdGet(provinceId) {
      return this.apiV1MyaccountCitiesProvinceIdGetWithHttpInfo(provinceId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Obtener provincias
     * Devuelve una lista de provincias.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ProvinceItem>} and HTTP response
     */
    apiV1MyaccountProvincesGetWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ProvinceItem];
      return this.apiClient.callApi(
        '/api/v1/myaccount/provinces', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Obtener provincias
     * Devuelve una lista de provincias.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ProvinceItem>}
     */
    apiV1MyaccountProvincesGet() {
      return this.apiV1MyaccountProvincesGetWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
